<template>
  <div class="reported_to_bid_forms">
    <transition name="fade" mode="out-in">
      <p v-if="isReportedToBidCurrentUser">
        {{ I18n.t("artworks.artwork_reported_to_bid") }}
      </p>
      <p v-else-if="error">
        {{ I18n.t('activerecord.errors.models.bid.attributes.live_auction.invalid_state') }}
      </p>
      <div v-else>
        <label>
          <b-btn v-b-tooltip.hover
                 :title="I18n.t('orders.reported_to_live_bid_info')"
                 class="btn-link link--orange global-search__tooltip reported-to-bid__tooltip p-0">
            <abbr data-original-title="" class="position-relative abbr"></abbr>
          </b-btn>
        </label>
        <input @click="reportArtworkToLiveBid()" type="button" class="btn"
               :value="I18n.t('artworks.report_artwork_to_live_bid')" />
      </div>
    </transition>
    <hr>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'ReportToBid',
    data() {
      return {
        error: false,
      };
    },
    props: {
      artwork: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['currentArtworkIndex']),
      isReportedToBidCurrentUser() {
        return Object.prototype.hasOwnProperty.call(this.artwork, 'reportedToBidArtworkForCurrentUser');
      },
    },
    methods: {
      ...mapActions(['reportToBid']),
      reportArtworkToLiveBid() {
        this.reportToBid({ id: this.artwork.id, index: this.currentArtworkIndex })
          .then((response) => {
            if (response.status === 422) this.error = true;
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/modal/orders/report_to_bid.vue?418ac81a